export const CommunicationPreferences = () => (
  <div>Communication Preferences</div>
);
